import { Crypto } from './crypto';

export const CRYPTO: Crypto = new Crypto();
